<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    components:{

    },
    data() {
        return {
            
        }
    },
    methods: {
       
    },
    mounted(){

    }
}
</script>


<style lang="scss">
#app,body {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    background: #F9F9F9;

    font-weight: 500;
    font-style: normal;
    text-transform: none;
    letter-spacing: normal;
}
</style>
